module.exports = __webpack_public_path__ + "img/photo-16.41001dc4.jpg";